import React from 'react';
import { FaSearch, FaSync, FaTimes } from 'react-icons/fa';

/**
 * Shared filter bar used by every log page.
 * Props:
 *   filters        – { search, status, dateFrom, dateTo, pageSize }
 *   onFilterChange – (key, value) => void
 *   onApply        – () => void
 *   onReset        – () => void
 *   statusOptions  – [{ value, label }]  (optional)
 *   loading        – bool
 */
const LogFilters = ({ filters, onFilterChange, onApply, onReset, statusOptions = [], loading }) => {
  const handleKey = (e) => { if (e.key === 'Enter') onApply(); };

  return (
    <div className="al-filters">
      {/* Search */}
      <div className="al-filter-group">
        <label className="al-filter-label">Search</label>
        <div style={{ position: 'relative' }}>
          <FaSearch style={{ position:'absolute', left:9, top:'50%', transform:'translateY(-50%)', color:'#9ca3af', fontSize:12 }} />
          <input
            className="al-filter-input"
            style={{ paddingLeft: 28, width: 200 }}
            placeholder="Search logs…"
            value={filters.search || ''}
            onChange={e => onFilterChange('search', e.target.value)}
            onKeyDown={handleKey}
          />
        </div>
      </div>

      {/* Date from */}
      <div className="al-filter-group">
        <label className="al-filter-label">From</label>
        <input
          type="date" className="al-filter-input"
          value={filters.dateFrom || ''}
          onChange={e => onFilterChange('dateFrom', e.target.value)}
        />
      </div>

      {/* Date to */}
      <div className="al-filter-group">
        <label className="al-filter-label">To</label>
        <input
          type="date" className="al-filter-input"
          value={filters.dateTo || ''}
          onChange={e => onFilterChange('dateTo', e.target.value)}
        />
      </div>

      {/* Status (optional) */}
      {statusOptions.length > 0 && (
        <div className="al-filter-group">
          <label className="al-filter-label">Status</label>
          <select
            className="al-filter-select"
            value={filters.status || ''}
            onChange={e => onFilterChange('status', e.target.value)}
          >
            <option value="">All</option>
            {statusOptions.map(o => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>
      )}

      {/* Page size */}
      <div className="al-filter-group">
        <label className="al-filter-label">Rows</label>
        <select
          className="al-filter-select"
          value={filters.pageSize || 25}
          onChange={e => onFilterChange('pageSize', Number(e.target.value))}
        >
          {[10, 25, 50, 100].map(n => <option key={n} value={n}>{n}</option>)}
        </select>
      </div>

      {/* Actions */}
      <button className="al-filter-btn primary" onClick={onApply} disabled={loading}>
        <FaSearch /> Apply
      </button>
      <button className="al-filter-btn secondary" onClick={onReset}>
        <FaTimes /> Reset
      </button>
    </div>
  );
};

export default LogFilters;
